<template>
  <div :class="'gallery-container'">
    <Hooper
      class="hooper-gal"
      :id="idString"
      :ref="idString"
      :itemsToShow="1"
      :itemsToSlide="1"
      :mouseDrag="false"
      :touchDrag="true"
      :wheelControl="false"
      @slide="hooperSlide"
    >
      <Slide v-for="(image, index) in data" :key="idString + index">
        <img class="slide-image" :src="image" />
      </Slide>
      <HooperPagination slot="hooper-addons"></HooperPagination>
    </Hooper>
    <button
      id="prevArrow"
      class="navArrow"
      @click="imageIndexSelected(currentImageIndex - 1)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185.343 185.343" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M51.707 185.343a10.692 10.692 0 01-7.593-3.149 10.724 10.724 0 010-15.175l74.352-74.347L44.114 18.32c-4.194-4.194-4.194-10.987 0-15.175 4.194-4.194 10.987-4.194 15.18 0l81.934 81.934c4.194 4.194 4.194 10.987 0 15.175l-81.934 81.939a10.678 10.678 0 01-7.587 3.15z" fill="#010002"/></svg>
    </button>

    <button
      id="nextArrow"
      class="navArrow"
      @click="imageIndexSelected(currentImageIndex + 1)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185.343 185.343" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M51.707 185.343a10.692 10.692 0 01-7.593-3.149 10.724 10.724 0 010-15.175l74.352-74.347L44.114 18.32c-4.194-4.194-4.194-10.987 0-15.175 4.194-4.194 10.987-4.194 15.18 0l81.934 81.934c4.194 4.194 4.194 10.987 0 15.175l-81.934 81.939a10.678 10.678 0 01-7.587 3.15z" fill="#010002"/></svg>
    </button>
  </div>
</template>


<script>
import { Hooper, Slide, Pagination as HooperPagination } from "hooper";
import "hooper/dist/hooper.css";
export default {
  name: "ImageGallery",
  components: {
    Hooper,
    Slide,
    HooperPagination,
  },
  data() {
    return {
      currentImageIndex: 0,
      isVertical: false,
    };
  },
  props: {
    idString: {
      type: String,
      required: false,
      default: "hooper-gallery-ref",
    },
    data: {
      type: Array,
      required: true,
    },
  },
  watch: {
    data: function (newVal, oldVal) {
      this.currentImageIndex = 0;
    },
  },
  mounted() {
    this.setListeners();
  },
  beforeDestroy() {
    this.removeListeners();
  },

  methods: {
    setListeners() {
      document.addEventListener("keydown", this.handleKey);
    },
    removeListeners() {
      document.removeEventListener("keydown", this.handleKey);
    },
    handleKey(e) {
      if (e && e.keyCode === 37) {
        this.imageIndexSelected(this.currentImageIndex - 1);
      }
      if (e && e.keyCode === 39) {
        this.imageIndexSelected(this.currentImageIndex + 1);
      }
    },
    imageIndexSelected(newIndex) {
      let ele = this.$refs[this.idString];
      const indexMax = this.data.length - 1;
      if (newIndex < 0) {
        newIndex = indexMax;
      } else if (newIndex > indexMax) {
        newIndex = 0;
      }
      ele.slideTo(newIndex);
    },
    hooperSlide(props) {
      this.currentImageIndex = props.currentSlide;
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery-container {
  width: 100%;
  position: relative;

  .hooper-gal {
    height: auto;
    outline: none;
  }

  .gallery-slide {
    position: relative;
    outline: none;
  }
  .slide-image {
    width: auto;
    object-fit: contain;
    height: auto;
    outline: none;
    max-height: 66vh;
  }
}

svg,
img {
  height: 24px;
  width: 24px;
}
.navArrow {
  transition: all 0.2s ease-in-out;
  background: transparent;
  border: none;
  margin: 15px;
  position: absolute;
  top: 50%;
  z-index: 5;
  transform: translateY(-100%);
  svg,
  img {
    height: 36px;
    width: 36px;
  }
  svg {
    path {
      fill: $lt-secondary-color;
    }
  }
}

#prevArrow {
  left: 0;
  img,
  svg {
    transform: rotate(180deg);
    outline: none;
  }
}
#nextArrow {
  right: 0;
  img,
  svg {
    outline: none;
  }
}
.navArrow:focus {
  outline: none;
}
</style>

<style lang="scss">
.hooper-track {
  .hooper-slide {
    width: 100% !important;
    max-height: 80vh;
  }
}

.hooper-pagination {
  padding-bottom: 14px;
  z-index: 99 !important;
  transform: translate(50%, 100%);
  .hooper-indicators {
    .hooper-indicator {
      height: 16px;
      width: 16px;
      border-radius: 50%;
      margin: 0 4px;
      outline: none;
      background-color: $lt-dark-gray;
      transition: all 0.1s ease-in;
      &:hover {
        cursor: pointer;
        background-color: $lt-secondary-color;
      }
    }

    .is-active {
      height: 20px;
      width: 20px;
      background-color: $lt-secondary-color;
    }
  }
}
</style>


<style lang="scss">
.dark {
  .hooper-pagination {
    .hooper-indicators {
      .hooper-indicator {
        background-color: $dt-font-color;

        &:hover {
          cursor: pointer;
          background-color: $dt-secondary-color;
        }
      }

      .is-active {
        background-color: $dt-secondary-color;
      }
    }
  }
}
</style>


